<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t bg-primary mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-white text-xl font-bold"> ویزیت متنی</h6>
  
      </div>
    </div>
    <!-- component -->
<div class="flex max-h-screen-75 antialiased bg-white text-gray-800">
    <div class="flex flex-row max-h-screen-75 w-full">
      
      <div class="flex flex-col flex-auto h-full p-6">
        <div
          class="flex flex-col flex-auto flex-shrink-0 rounded-2xl h-full p-4"
        >
          <div class="flex flex-col h-full overflow-y-auto mb-4">
            <div class="flex flex-col h-full">
              <div class="grid grid-cols-12 gap-y-2">
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>Hey How are you today?</div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Vel ipsa commodi illum saepe numquam maxime
                        asperiores voluptate sit, minima perspiciatis.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                      <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>I'm ok what about you?</div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                    <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit, amet consectetur adipisicing. ?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>Lorem ipsum dolor sit amet !</div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                    <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit, amet consectetur adipisicing. ?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Perspiciatis, in.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Vel ipsa commodi illum saepe numquam maxime
                        asperiores voluptate sit, minima perspiciatis.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                      <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>I'm ok what about you?</div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                    <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit, amet consectetur adipisicing. ?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>Lorem ipsum dolor sit amet !</div>
                    </div>
                  </div>
                </div>
                <div class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div class="flex items-center justify-start flex-row-reverse">
                    <div
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0"
                    >
                    <img class=" rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
                    </div>
                    <div
                      class="relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit, amet consectetur adipisicing. ?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-start-1 col-end-8 p-3 rounded-lg">
                  <div class="flex flex-row items-center">
                    <!-- <div
                      class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div> -->
                    <div
                      class="relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded"
                    >
                      <div>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Perspiciatis, in.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex flex-row items-center h-16 rounded bg-white w-full px-4"
          >
            <div>
              <button
                class="flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="flex-grow ml-4">
              <div class="relative w-10/12">
                <textarea name="" id="" rows="3" cols="20"
                class="flex w-full border rounded focus:outline-none focus:border-indigo-300 px-4 m-4 h-16"
                ></textarea>
              </div>
            </div>
            <div class="ml-4">
              <button
                class="flex items-center justify-center bg-primary rounded text-white px-2 py-1 flex-shrink-0"
              >
                <img class="send-btn w-8" src="../../../../assets/img/icon/send.svg" alt="">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>